import React, { ReactNode } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import cx from 'classnames';

interface IProps {
  className?: string;
  withPadding?: boolean;
  style?: any;
  bottomContent?: ReactNode;
}
const CardFundContent: React.FC<IProps> = ({
  className,
  children,
  bottomContent,
  ...props
}) => {
  return (
    <Card className={cx('p-3', 'overflow-hidden', className)} {...props}>
      <Card.Body className="p-0">
        <Row className="m-0">
          <Col className={cx('p-0', 'relative')}>{children}</Col>
        </Row>
        <Row className="m-0 pl-2 pr-2">{bottomContent}</Row>
      </Card.Body>
    </Card>
  );
};

export default CardFundContent;
